<template lang="pug">
.articleNoThumbnail-item
  //- top section of articleNoThumbnail
  .articleNoThumbnail-top(@click="goTo")
    v-clamp.articleNoThumbnail-text.heading-cardTitle(autoresize :max-lines="2") {{ info.title }}
  //- middle section of articleNoThumbnail
  .articleNoThumbnail-middle
    .articleNoThumbnail-time
      .color--greyBlue90 {{ time }}
    .articleNoThumbnail-report
      i.icon-report2.articleNoThumbnail-icon
      .color--greyBlue90 {{ getNumberString(info.reporterCount) }}
    .articleNoThumbnail-follow
      //- will show the blue version of the eye icon when isFollowing is true
      i.articleNoThumbnail-icon(:class="identity == 'users'")
      //- will change text color to blue when isFollowing is true
      //- div(:class="identity == 'users' && followed ? 'color--blueCornFlower' : 'color--greyBlue90'") {{ getNumberString(followerCount) }}


  //- bottom section of articleNoThumbnail
  .articleNoThumbnail-bottom
    .articleNoThumbnail-tag(:class="getTagClass(5, 'articleNoThumbnail-tag')") 澄清
    .articleNoThumbnail-info
      span.articleCard-info-partner {{ info.govOption.name}}
    
</template>
<script>
import { getTime, getTagClass, getNumberString } from '@/plugins/tool.js';
import VClamp from 'vue-clamp';
export default {
  components: {
    VClamp
  },
  props: {
    info: Object,
    idx: Number,
    staticData: Object,
    token: String
  },
  data() {
    return {
      tagClass: '',
      localFollowStatus: null,
      getNumberString: getNumberString,
      identity: localStorage.getItem(this.$store.state.storageKeys.identity)
    };
  },
  computed: {
    time() {
      return getTime(this.info.updatedAt);
    }
  },
  methods: {
    goTo() {
      this.$router.push({
        path: '/gov-announce',
        query: {
          govAnnounceId: this.info.id,
          govOptionName: this.info.govOption.name,
          govOptionId: this.info.govOption.id
        }
      });
    },
    getTagClass(tagId, className) {
      return getTagClass(tagId, className);
    }
  }
};
</script>
